module.exports = __webpack_public_path__ + "img/viz-bar--full.f4998618.svg";